import React from 'react';
import PropTypes from 'prop-types';
import { Input, message } from 'antd';
import Flex from '../../../shared/components/basic/Flex';
import { Text } from '../../../shared/components';
import { debounce } from '../../../../helpers/common.helper';

export default class GraduacionInputs extends React.Component {
  constructor(props) {
    super(props);
    const { getLentesListRequest } = props;
    this.gentLentesListDebounced = debounce(getLentesListRequest, 700);
  }

  render() {
    const {
      graduacion: { generico },
      ordenGraduacion,
      onGraduacionChange,
      setSeleccionPasillo,
    } = this.props;
    const getAddon = text => (
      <Text color="#BFBFBF">{text}</Text>
    );
    const getValueWithSign = (valor, hasDot, isFloat) => {
      let valueWithNoDot = valor;
      if (hasDot) {
        valueWithNoDot = valor.slice(0, -1);
      }
      let value = isFloat ? parseFloat(valueWithNoDot) : parseInt(valueWithNoDot, 10);
      if (value > 0) {
        value = `+${value}`;
      }
      return value;
    };
    const getFormattedValue = (valor, hasSign = false, isFloat = false, isOnlyPositive = false, onlyPositiveWarning = false) => {
      let value = valor;
      if (valor !== '-' && valor !== '+' && valor !== null && valor !== '' && ((!isOnlyPositive && valor !== '-0' && valor !== '-0.') || (isOnlyPositive))) {
        const hasDot = valor.slice(-1) === '.';
        const moreThanOneDot = (valor.split('.').length > 2);
        if (hasSign) value = getValueWithSign(value, hasDot, isFloat);
        if (hasDot && isFloat && hasSign && !moreThanOneDot) value = `${value}.`;
        if (!hasSign && moreThanOneDot && isFloat) value = valor.slice(0, -1);
        if (!isFloat) value = parseInt(value, 10);
      }
      if (value === '-0' || value === '-0') {
        if (!isOnlyPositive) {
          value = `-${Math.abs(value)}`;
        }
      }
      if (value === '-' && isOnlyPositive) {
        if (onlyPositiveWarning) {
          message.warning('Las tarifas se consultan con cilindro positivo');
        }
        value = null;
      }
      return value;
    };
    const handleGraduacionChangeWithSign = (valor, tipo, testFloat = true, isOnlyPositive = false) => {
      if (isOnlyPositive && valor.slice(0, 1) === '-') return;
      const isItFloat = str => /[+-]?([0-9]*[.])?[0-9]+/.test(str);
      const isPositiveInteger = str => /^[0-9]\d*$/.test(str);
      let value = valor;
      if (!isItFloat(valor) && testFloat) {
        if (valor !== '-' && valor !== '+' && valor !== '') return;
      }
      if (!testFloat && !isPositiveInteger) {
        return;
      }
      if (!testFloat && isOnlyPositive && parseInt(value, 10) < 0) return;
      if (tipo === 'adicion' && valor !== null && valor !== '') {
        setSeleccionPasillo(1);
      } else if (tipo === 'adicion') {
        setSeleccionPasillo(0);
      }
      if (value === '-' && isOnlyPositive) {
        value = null;
      }
      onGraduacionChange(value, tipo);
      this.gentLentesListDebounced();
    };
    const debouncedHandleGraduacionChangeWithSign = debounce(handleGraduacionChangeWithSign, 700);
    const orderGrad = ordenGraduacion ? ordenGraduacion.split(';') : null;
    if (orderGrad && orderGrad[0] === 'EsfL') {
      return (
        <Flex className="graduacionInputs">
          <Input
            // prefix={getSign(generico.ESF)}
            size="small"
            addonBefore={getAddon('Esf')}
            onChange={({ target: { value } }) => handleGraduacionChangeWithSign(value, 'esfera')}
            style={{ width: 98, marginRight: 8 }}
            value={getFormattedValue(generico.ESF, true, true)}
          />
          <Input
            // prefix={getSign(generico.CIL)}
            size="small"
            addonBefore={getAddon('Cil')}
            onChange={({ target: { value } }) => handleGraduacionChangeWithSign(value, 'cilindro')}
            style={{ width: 98, marginRight: 8 }}
            value={getFormattedValue(generico.CIL, true, true, true, true)}
          />
          <Input
            size="small"
            addonBefore={getAddon('Eje')}
            onChange={({ target: { value } }) => handleGraduacionChangeWithSign(value, 'eje', false, true)}
            style={{ width: 98, marginRight: 8 }}
            value={getFormattedValue(generico.AXIS, false, false)}
          />
          <Input
            // prefix={getSign(generico.ADD)}
            size="small"
            addonBefore={getAddon('Adi')}
            onChange={({ target: { value } }) => handleGraduacionChangeWithSign(value, 'adicion')}
            style={{ width: 98, marginRight: 8 }}
            value={getFormattedValue(generico.ADD, false, true)}
          />
        </Flex>
      );
    }
    return (
      <Flex className="graduacionInputs">
        <Input
          size="small"
          addonBefore={getAddon('Eje')}
          onChange={({ target: { value } }) => handleGraduacionChangeWithSign(value, 'eje', false, true)}
          style={{ width: 98, marginRight: 8 }}
          value={getFormattedValue(generico.AXIS, false, false)}
        />
        <Input
            // prefix={getSign(generico.CIL)}
          size="small"
          addonBefore={getAddon('Cil')}
          onChange={({ target: { value } }) => handleGraduacionChangeWithSign(value, 'cilindro')}
          style={{ width: 98, marginRight: 8 }}
          value={getFormattedValue(generico.CIL, true, true)}
        />
        <Input
            // prefix={getSign(generico.ESF)}
          size="small"
          addonBefore={getAddon('Esf')}
          onChange={({ target: { value } }) => handleGraduacionChangeWithSign(value, 'esfera')}
          style={{ width: 98, marginRight: 8 }}
          value={getFormattedValue(generico.ESF, true, true)}
        />
        <Input
            // prefix={getSign(generico.ADD)}
          size="small"
          addonBefore={getAddon('Adi')}
          onChange={({ target: { value } }) => handleGraduacionChangeWithSign(value, 'adicion')}
          style={{ width: 98, marginRight: 8 }}
          value={getFormattedValue(generico.ADD, false, true)}
        />
      </Flex>
    );
  }
}
GraduacionInputs.propTypes = {
  graduacion: PropTypes.shape({
    generico: PropTypes.shape({
      AXIS: PropTypes.number,
      CIL: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      ADD: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      ESF: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }).isRequired,
  }).isRequired,
  onGraduacionChange: PropTypes.func,
  getLentesListRequest: PropTypes.func,
  setSeleccionPasillo: PropTypes.func,
  ordenGraduacion: PropTypes.string,
};
GraduacionInputs.defaultProps = {
  onGraduacionChange: () => {},
  getLentesListRequest: () => {},
  setSeleccionPasillo: () => {},
  ordenGraduacion: null,
};
